<template>
  <div id="bulk-attendance">
    <b-container>
      <div id="attendance-form">
        <h4 class="subtitle mt-4">Students' Attendance</h4>
        <b-button
          variant="primary"
          v-if="showTable === false && isAdmin || isSRC"
          class="mt-2"
          @click="
            (showTable = !showTable), (showForm = !showForm), loadStudents()
          "
          >Add Attendance Record</b-button
        >
        <b-row
          v-if="showForm === true || buttonTitle === 'Edit Attendance Records'"
        >
          <b-col>
            <label for="workshop_date">Month</label>
            <b-form-select
              name="month"
              type="text"
              id="month"
              v-model="recordMonth"
              @change="monthUpdate($event)"
            >
              <option disabled value>Select Month</option>
              <option v-for="(month, i) in months" :key="i" :value="month">
                {{ month }}
              </option>
            </b-form-select>
            <p class="err" v-if="!monthError">Please select a month.</p>
          </b-col>
          <b-col>
            <label for="workshop_date">Year</label>
            <b-form-select
              name="year"
              type="text"
              id="year"
              v-model="recordYear"
              @change="yearUpdate($event)"
            >
              <option disabled value>Select a Year</option>
              <option
                v-for="year in availableYears"
                :key="year.id"
                :value="year"
                >{{ year }}</option
              >
            </b-form-select>
            <p class="err" v-if="!yearError">Please select a year.</p>
          </b-col>
          <b-col>
            <label for="total_days">Total Days</label>
            <b-form-input
              name="totalDays"
              type="number"
              :min="0"
              :max="30"
              id="totalDays"
              v-model.number="totalDays"
              @change="totalDaysUpdate($event)"
            ></b-form-input>
            <p class="err" v-if="!daysError">
              Please enter total school days in month.
            </p>
          </b-col>
        </b-row>
        <b-form-group class="m-4" v-if="showTable === true">
          <div id="new-attendance">
            <label for="new-attendance">{{ tableTitle }}</label>
            <b-table
              v-cloak
              responsive
              :fields="newAttendanceFields"
              :items="oneMonthAttendance"
              :striped="true"
              :bordered="true"
              :hover="true"
              stacked="md"
              small
            >
              <template slot="cell(present)" slot-scope="row">
                <b-form-group
                  :id="row.item.student_uuid"
                  :value="row.item.present"
                >
                  <b-form-input
                    name="present"
                    type="number"
                    id="present"
                    v-model.number="row.item.present"
                    :min="0"
                    :max="totalDays"
                    @change="updateStudentAttendance(row.item)"
                  ></b-form-input>
                  <p
                    class="err"
                    v-if="totalDays < row.item.present || row.item.present < 0"
                  >
                    Please ensure this value is less than the total days in the
                    month.
                  </p>
                </b-form-group>
              </template>
            </b-table>
          </div>
          <b-button
            variant="primary"
            class="mt-2"
            @click="
              (showTable = !showTable),
                (showForm = !showForm),
                addBulkStudentAttendance()
            "
            >{{ buttonTitle }}</b-button
          >
        </b-form-group>
        <b-row>
          <b-form-group class="right m-4">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Type to Search" />
              <b-input-group-append>
                <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
          <div id="alerts" ref="attendance-alert">
            <b-alert
              :show="dismissCountDown"
              dismissible
              variant="success"
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged"
              >You have successfully added an attendance record!</b-alert
            >
            <b-alert :show="showError" dismissible variant="warning">
              Something went wrong. Please refresh and try again, or contact the
              site admin.
            </b-alert>
          </div>
          <b-table
            v-cloak
            v-if="cleanedSummaryTable.length"
            responsive
            :fields="attendanceSummaryFields"
            :items="cleanedSummaryTable"
            :striped="true"
            :bordered="true"
            :hover="true"
            stacked="md"
            small
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="cell(avg_present)" slot-scope="row">
              {{ row.item.avg_present | percent }}
            </template>
            <template slot="cell(edit)" slot-scope="row">
              <b-link
                class="edit"
                v-if="isAdmin || isSRC"
                @click.stop="
                  (showForm = !showForm), editAttendanceMonth(row.item)
                "
                >EDIT</b-link
              >
            </template>
          </b-table>
          <b-row>
            <b-col md="6" class="my-1">
              <b-pagination
                :total-rows="totalRows"
                :per-page="perPage"
                v-model="currentPage"
                class="my-0"
              />
            </b-col>
          </b-row>
        </b-row>
      </div>
    </b-container>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import AttendanceService from "@/services/AttendanceService";
import { flash } from "@/mixins/flashes";
import { scrollTo } from "@/mixins/scrollTo";

export default {
  name: "BulkAttendance",
  mixins: [flash, scrollTo],
  data() {
    return {
      buttonTitle: "Add Attendance Records",
      months: this.$store.state.months,
      recordMonth: "",
      recordYear: "",
      totalDays: 0,
      newAttendanceFields: [
        { key: "student_name", label: "Student", sortable: true },
        { key: "present", label: "Days Present", sortable: false },
      ],
      attendanceSummaryFields: [
        { key: "year_month", label: "Year/Month", sortable: true },
        {
          key: "avg_present",
          label: "Average Percent Present",
          sortable: true,
        },
        { key: "total_days", label: "total_days", sortable: true },
        { key: "edit", label: "EDIT" },
      ],
      newStudentAttendance: [],
      filter: "",
      showTable: false,
      showForm: false,
      currentPage: 1,
      perPage: 20,
    };
  },
  methods: {
    ...mapActions({
      GET_SUMMARY_TABLE: "attendance/GET_ATTENDANCE_SUMMARY_TABLE",
      GET_ONE_MONTH_ATTENDANCE: "attendance/GET_ONE_MONTH_ATTENDANCE",
      ADD_BULK_ATTENDANCE: "attendance/ADD_BULK_ATTENDANCE",
      BULK_UPDATE_ALL: "attendance/BULK_UPDATE_ALL",
    }),
    ...mapMutations(
      "attendance/oneMonthAttendance",
      "attendance/bulkAddMonth",
      "attendance/bulkAddYear",
      "attendance/bulkAddTotalDays"
    ),
    clearForm() {
      Object.assign(this.$data, initialState());
    },
    loadStudents() {
      // set an empty array
      // bring in students from teacherStudents
      let students = this.$store.state.teachers.teacherStudents;
      // get student_id, name, present and month/year/total_days
      students = students.map((key) => ({
        id: 0,
        student_uuid: key.student_uuid,
        student_name: `${key.first_name} ${key.last_name}`,
        present: 0,
        total_days: 0,
        month: "",
        year: "",
      }));
      this.newStudentAttendance = students;
      this.$store.commit("attendance/oneMonthAttendance", students);
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async monthUpdate(event) {
      await this.$store.commit("attendance/bulkAddMonth", event);
      const month = event;
      const year = this.recordYear;

      if (this.buttonTitle !== "Add Attendance Records") {
        await this.BULK_UPDATE_ALL();
        await this.GET_SUMMARY_TABLE();
        await this.GET_ONE_MONTH_ATTENDANCE({
          teacherId: this.$route.params.id,
          month,
          year,
        });
      } else {
      }
    },
    async yearUpdate(event) {
      this.$store.commit("attendance/bulkAddYear", event);
      const month = this.recordMonth;
      const year = event;

      if (this.buttonTitle !== "Add Attendance Records") {
        await this.BULK_UPDATE_ALL();
        await this.GET_SUMMARY_TABLE();
        await this.GET_ONE_MONTH_ATTENDANCE({
          teacherId: this.$route.params.id,
          month,
          year,
        });
      } else {
      }
    },
    async totalDaysUpdate(event) {
      this.$store.commit("attendance/bulkAddTotalDays", parseInt(event));
      const month = this.recordMonth;
      const year = this.recordYear;

      if (this.buttonTitle !== "Add Attendance Records") {
        await this.BULK_UPDATE_ALL();
        await this.GET_SUMMARY_TABLE();
        await this.GET_ONE_MONTH_ATTENDANCE({
          teacherId: this.$route.params.id,
          month,
          year,
        });
      } else {
      }
    },
    async addBulkStudentAttendance() {
      if (this.recordMonth === "" || this.recordYear === "" || this.totalDays) {
        alert("Please add a month, date, and total days");
        return;
      }
      if (this.buttonTitle === "Add Attendance Records") {
        await this.ADD_BULK_ATTENDANCE();
      } else {
        this.buttonTitle = "Add Attendance Records";
      }
    },
    async updateStudentAttendance(row) {
      if (this.recordMonth === "" || this.recordYear === "" || this.totalDays) {
        alert("Please add a month, date, and total days");
        return;
      }
      const payload = {
        id: row.id,
        student_uuid: row.student_uuid,
        month: this.recordMonth,
        year: this.recordYear,
        total_days: this.totalDays,
        present: row.present,
      };
      await AttendanceService.updateAttendanceRecord(payload);
      await this.GET_SUMMARY_TABLE();
    },
    async editAttendanceMonth(row) {
      this.buttonTitle = "Edit Attendance Records";
      const date = row.year_month;
      const year = date.substr(0, date.indexOf("-"));
      const month = date.split("-")[1];
      const totalDays = row.total_days;

      await this.GET_ONE_MONTH_ATTENDANCE({
        teacherId: this.$route.params.id,
        month,
        year,
      });
      this.showTable = true;
      this.recordMonth = month;
      this.recordYear = year;
      this.totalDays = totalDays;
    },
  },
  computed: {
    ...mapGetters({
      isAdmin: "auth/isAdmin",
      isSRC: "auth/isSRC",
    }),
    totalRows() {
      if (this.summaryTable.length > 0) {
        return this.summaryTable.length;
      }
    },
    oneMonthAttendance: {
      get() {
        return this.$store.state.attendance.oneMonthAttendance;
      },
    },
    summaryTable: {
      get() {
        return this.$store.state.attendance.attendanceSummaryTable;
      },
    },
    cleanedSummaryTable() {
      return this.summaryTable.map((k) => {
        k.avg_present = parseFloat(k.avg_present);
        return k;
      });
    },
    availableYears() {
      const now = new Date();
      const year = now.getFullYear();
      return [year.toString(), (year - 1).toString(), (year - 2).toString()];
    },
    yearError() {
      return this.recordYear.length;
    },
    monthError() {
      return this.recordMonth.length;
    },
    daysError() {
      return this.totalDays > 0;
    },
    presentError(days) {
      return this.totalDays > days || days < 0;
    },
    tableTitle() {
      return this.buttonTitle === "Add Attendance Record"
        ? "New Attendance Record"
        : `Edit Attendance from ${this.recordMonth}, ${this.recordYear}`;
    },
  },
  mounted() {
    this.GET_SUMMARY_TABLE();
  },
};
</script>

<style scoped>
.err {
  color: red;
  text-emphasis: italic;
}
.right {
  float: right;
}
</style>
